import { contentServicePost } from 'infrastructure/contentService'

/**
 * Start a URL replacement job
 *
 * @param tree_id - The tree ID
 * @param version_id - The version ID
 * @param replacements - Array of URL mappings to replace
 * @returns Promise<string> - The flow ID for tracking job status
 *
 * @throws Error if the API request fails or no flow ID is returned
 *
 * @example
 * const flowId = await startUrlReplacement({
 *   tree_id: 'tree123',
 *   version_id: 'v1',
 *   replacements: [
 *     { old_url: 'https://old.com/page', new_url: 'https://new.com/page' }
 *   ]
 * })
 */
export async function startUrlReplacement({
  tree_id,
  version_id,
  replacements,
}: {
  tree_id: string
  version_id: string
  replacements: Array<{ old_url: string; new_url: string }>
}): Promise<string> {
  const { result, error } = await contentServicePost<{ flow_id: string }>({
    path: '/content/v1/url_replacement',
    body: { tree_id, version_id, replacements },
  })

  if (error || !result?.flow_id) {
    throw new Error(
      error
        ? `URL replacement start failed: ${error}`
        : 'No flow ID received from API',
    )
  }

  return result.flow_id
}
